import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Logo from '../../components/Logo';

const Recrutement = () => {
  const methods = [
    { title: 'Définition du Profil', desc: 'Scorecard précise basée sur vos besoins réels et votre culture.' },
    { title: 'Sourcing Actif', desc: 'Chasse proactive des meilleurs talents sur LinkedIn et réseaux spécialisés.' },
    { title: 'Assessment Structuré', desc: 'Process d\'évaluation rigoureux avec mises en situation et roleplay.' },
    { title: 'Onboarding Accéléré', desc: 'Programme d\'intégration structuré pour une montée en puissance rapide.' },
  ];

  const results = [
    { value: '-50%', label: 'temps de recrutement' },
    { value: '90%', label: 'rétention à 1 an' },
    { value: '3 mois', label: 'ramp-up moyen' },
    { value: '+40%', label: 'performance vs moyenne' },
  ];

  return (
    <div className="bg-[#F5F5F5] min-h-screen">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-[#041C2C] to-[#0a2a3d]">
        <div className="max-w-6xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white mb-8 transition-colors">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Retour
          </Link>
          
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#2A41E5]/20 border border-[#2A41E5]/30 mb-6">
            <span className="text-sm text-[#2A41E5] font-medium">Expertise</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Recrutement Sales
          </h1>
          <p className="text-xl text-white/70 max-w-3xl leading-relaxed">
            Sourcing, assessment et onboarding de profils commerciaux performants. 
            Trouvez les talents qui feront la différence.
          </p>
        </div>
      </section>

      {/* Résultats */}
      <section className="py-16 px-6 bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {results.map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-[#2A41E5] mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Notre approche */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">Notre approche</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {methods.map((method, idx) => (
              <div 
                key={idx}
                className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-[#2A41E5]/30 hover:shadow-lg transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-[#2A41E5]/10 flex items-center justify-center flex-shrink-0">
                    <span className="text-[#2A41E5] font-bold">{idx + 1}</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{method.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{method.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Recrutez les meilleurs
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Discutons de vos besoins en recrutement commercial et comment trouver les bons profils.
          </p>
          <a
            href="https://meetings-eu1.hubspot.com/younes8" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#2A41E5] text-white font-bold rounded-xl hover:bg-[#1E32B8] transition-all duration-300 hover:shadow-lg hover:shadow-[#2A41E5]/30"
          >
            Réserver un appel découverte
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 px-6 bg-[#1A1A1A]">
        <div className="max-w-7xl mx-auto flex flex-col items-center justify-center gap-6">
          <Logo variant="white" height={28} />
          <p className="text-gray-400">&copy; 2024 FOMOW. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
};

export default Recrutement;
